module.exports = __webpack_public_path__ + "img/motiontech.61395ea0.png";